var exports = {
  "k": "container__Uw_oRQ",
};

module.exports = exports;
